// A generated link, shown as a labelled read-only field with a copy
// button and a polite status region.
//
// Promoted out of ShareLinkDrawer (its inline block was the original) the
// moment a second surface needed the same thing — ActivateUnitDrawer's
// invitation link. The three things worth not re-deriving per surface:
//
//   1. The input carries a real <label>, not a bare box. The share
//      drawer's original had none, so a screen reader announced an
//      unlabelled text field holding an opaque URL.
//   2. `ph-no-capture` on BOTH the input and the button. A share/accept
//      URL is a bearer credential — PostHog session replay must not
//      record the value, and a button whose label flips on copy is
//      enough of a signal to keep out of the replay too.
//   3. The copy failure branch is silent on purpose: clipboard
//      permission can be denied outright, and the URL is still there as
//      selectable text (onFocus selects it), which is the fallback. A
//      thrown error banner would be worse than the already-visible value.

import { useState } from "react";

export function CopyLinkField({ id, label, value }: { id: string; label: string; value: string }) {
  const [copied, setCopied] = useState(false);

  async function onCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard permission denied or unavailable — the URL stays
      // visible as selectable text, which is the fallback.
    }
  }

  return (
    <>
      <div className="field">
        <label className="field__label" htmlFor={id}>
          {label}
        </label>
        <input
          id={id}
          className="input ph-no-capture"
          type="text"
          readOnly
          value={value}
          onFocus={(e) => e.currentTarget.select()}
        />
      </div>
      <button
        type="button"
        className="btn btn--primary ph-no-capture"
        onClick={() => void onCopy()}
      >
        {copied ? "Copiado ✓" : "Copiar enlace"}
      </button>
      <p role="status" aria-live="polite" className="cell-sub copy-link__status">
        {copied ? "Enlace copiado al portapapeles." : ""}
      </p>
    </>
  );
}
